angular.module('natura').provider(
  "pggEloirasProvider",
  [function () {
    /**
     * CONFIG
     */
    var config = {
      options: []
    };

    this.$get = [
      "$http",
      "pggConfigProvider",
      function ($http, pggConfigProvider) {
        /**
         * GETTERS AND SETTERS
         */
        var _getOptions = function () {
          return config.options;
        };
        var _setOptions = function (options) {
          config.options = options;
        };

        /**
         * FUNCTIONS
         */
        /**
         * Legördülő elemeinek lekérése
         */
        var _getOptionsParametersPromise = function () {
          var promise = $http.get(pggConfigProvider.getBaseUrl() + "/q/egyeb/szabalyok-elfogadasa").then(
            function (response) {
              return response;
            });
          return promise;
        };
        /**
         * Előírások lekérdezése geometria id-k szerint
         * 
         * @param idArray:
         *          geometria id-k tömbje
         */
        var _getMetszetEloirasByFeatureIdArrayPromise = function (idArray) {
          var postData = {
            featureIds: []
          };
          angular.forEach(idArray, function (id) {
            postData.featureIds.push(id);
          });
          var promise = $http.post(pggConfigProvider.getBaseUrl() + "/szabalyok/metszet", postData).then(
            function (response) {
              return response;
            });
          return promise;
        };

        var _getMetszetByFeatureIdPromise = function (id) {
          var promise = $http.get(pggConfigProvider.getBaseUrl() + "/gis/metszet/" + id).then(function (response) {
            return response;
          });
          return promise;
        };

        /**
         * Egy sima előírás tömböt szétszed, és aggregálja kezelési egységek
         * szerint, valamint a metszetek geojson alapján egyéb
         * attribútumokat is hozzárendel (geometria + egyéb)
         * 
         * @param eloirasok:
         *          kezelési egységek tömbje
         * @param metszetek:
         *          metszet geojson
         */
        var _extractEloirasokByKezelesiEgysegNew = function (eloirasok, metszetek) {
          var kezelesiEgysegek = [];
          var aggregated = [];
          angular.forEach(eloirasok, function (eloiras) {
            var idx = kezelesiEgysegek.indexOf(eloiras.ke_kod);
            if (idx == -1) {
              kezelesiEgysegek.push(eloiras.ke_kod);
              ertekelt = [];
              if (eloiras.declaration_id != 12) {
                ertekelt.push(eloiras);
              }
              aggregated.push({
                ke_kod: eloiras.ke_kod,
                ke_nev: eloiras.ke_nev,
                geojson: {},
                ruleCodes: [eloiras.rule_code],
                ertekelt: ertekelt,
                children: [eloiras]
              });
            } else {
              //csak akkor tegye bele az előírást, ha még nem szerepelt az adott kezelési egységhez
              if (aggregated[idx].ruleCodes.indexOf(eloiras.rule_code) == -1) {
                aggregated[idx].ruleCodes.push(eloiras.rule_code);
                if (eloiras.declaration_id != 12) {
                  aggregated[idx].ertekelt.push(eloiras);
                }
                aggregated[idx].children.push(eloiras);
              }
            }
          });
          // geometria és egyéb attribútumok betöltése a metszet alapján
          angular.forEach(metszetek.features, function (feat) {
                var kod = feat.properties.ke_kod;
                var ix2 = kezelesiEgysegek.indexOf(kod);
                if (ix2 != -1) {
                  var aggr = aggregated[ix2];
                  // ha még nem volt geometria, akkor simán beletesszük a
                  // geojson
                  // tartalmát (Polygon vagy MultiPolygon is lehet)
                  if (!aggr.geojson.hasOwnProperty("geometry")) {
                    aggr.geojson = feat;
                  } else {
                    // ha már volt geometria, akkor mindenképp MultiPolygon-ná
                    // kell
                    // alakítani
                    if (aggr.geojson.geometry.type != "MultiPolygon") {
                      aggr.geojson.geometry.type = "MultiPolygon";
                      aggr.geojson.geometry.coordinates = [aggr.geojson.geometry.coordinates];
                    }
                    // ...és utána lehet beletolni a feat koordinátáit
                    // de itt is különbséget kell tenni, hogy a feat az
                    // MultiPolygon
                    // vagy Polygon
                    if (feat.geometry.type == "MultiPolygon") {
                      angular.forEach(feat.geometry.coordinates, function (coords) {
                        aggr.geojson.geometry.coordinates[0].push(coords[0]);
                      });
                    } else {
                      aggr.geojson.geometry.coordinates[0].push(feat.geometry.coordinates[0]);
                    }
                  }
                }
              });
              return aggregated;
            };

            var _extractEloirasokByKezelesiEgyseg = function (eloirasok, metszetek) {
              // distinct gyűjteménye a kezelési egységeknek
              var kezelesiEgysegek = [];
              var aggregated = [];
              angular.forEach(eloirasok, function (eloiras) {
                // megnézi, hogy az adott kezelési egység szerepelt-e már
                // korábban
                var idx = kezelesiEgysegek.indexOf(eloiras.bid);
                // ha még nem szerepelt korábban
                if (idx == -1) {
                  // hozzáadja a distinct kezelési egységekhez
                  kezelesiEgysegek.push(eloiras.bid);
                  // létrehoz az aggregáltban egy új objektumot, aminek a neve a
                  // kezelés egység kódja, a "children" pedig egy üres tömb, ide
                  // kerülnek majd az ide tartozó előírások
                  aggregated.push({
                    "ke_kod": eloiras.ke_kod,
                    "ke_nev": eloiras.ke_nev,
                    "bid": eloiras.bid,
                    "children": [],
                    "geojson": {}
                  });
                } else {
                  // az aggregált tömb megfelelő objektumát feltölti a kezelési
                  // egységgel
                  aggregated[idx].children.push(eloiras);
                }
              });
              // geometria és egyéb attribútumok betöltése a metszet alapján
              angular.forEach(metszetek.features, function (feat) {
                var kod = feat.properties.ke_kod;
                var bid = feat.properties.bid;
                var ix2 = kezelesiEgysegek.indexOf(bid);
                if (ix2 != -1) {
                  var aggr = aggregated[ix2];
                  // ha még nem volt geometria, akkor simán beletesszük a
                  // geojson
                  // tartalmát (Polygon vagy MultiPolygon is lehet)
                  if (!aggr.geojson.hasOwnProperty("geometry")) {
                    aggr.geojson = feat;
                  } else {
                    // ha már volt geometria, akkor mindenképp MultiPolygon-ná
                    // kell
                    // alakítani
                    if (aggr.geojson.geometry.type != "MultiPolygon") {
                      aggr.geojson.geometry.type = "MultiPolygon";
                      aggr.geojson.geometry.coordinates = [aggr.geojson.geometry.coordinates];
                    }
                    // ...és utána lehet beletolni a feat koordinátáit
                    // de itt is különbséget kell tenni, hogy a feat az
                    // MultiPolygon
                    // vagy Polygon
                    if (feat.geometry.type == "MultiPolygon") {
                      angular.forEach(feat.geometry.coordinates, function (coords) {
                        aggr.geojson.geometry.coordinates[0].push(coords[0]);
                      });
                    } else {
                      aggr.geojson.geometry.coordinates[0].push(feat.geometry.coordinates[0]);
                    }
                  }
                }
              });
              return aggregated;
            };

            var _getModifiedEloirasok = function (eloiras_table_isDirty, eloirasok) {
              var modifiedEloirasok = {
                declarations: []
              };
              if (eloiras_table_isDirty) {
                // végig kell menni az egyes kezelési egységeken, illetve azok
                // children elemein
                angular.forEach(eloirasok, function (kezelesiEgyseg) {
                  angular.forEach(kezelesiEgyseg.children, function (eloiras) {
                    // ha az előírás kezdeti értéke (declaration_id) nem egyezik
                    // meg
                    // a
                    // legördülő értékével (selected.id), akkor be kell tenni a
                    // küldendő tömbbe
                    if (eloiras.declaration_id != eloiras.selected.id) {
                      // a json tartalma megfelel a {{url}}/szabalyok/elfogadasa
                      // hívásához szükséges paramétereknek
                      modifiedEloirasok.declarations.push({
                        obj: eloiras,
                        geometry_id: eloiras.geom_id,
                        rule_id: eloiras.rule_id,
                        declaration_id: eloiras.selected.id
                      });
                    }
                  });
                });
              }
              return modifiedEloirasok;
            };

            /**
             * TODO
             */
            var _putModifiedEloirasokPromise = function (modifiedEloirasok) {
              var postData = {
                declarations: []
              };
              angular.forEach(modifiedEloirasok, function (eloiras) {
                postData.declarations.push({
                  obj: eloiras,
                  handled_unit_id: eloiras.bid,
                  geometry_id: +eloiras.aid,
                  rule_id: +eloiras.rule_code,
                  declaration_id: +eloiras.selectedEloirasId
                });
              });
              var promise = $http.put(pggConfigProvider.getBaseUrl() + "/szabalyok/elfogadasa", postData).then(
                function (response) {
                  return response;
                });
              return promise;
            };

            /**
             * RETURNS
             */
            return {
              getOptions: _getOptions,
              setOptions: _setOptions,
              getOptionsParametersPromise: _getOptionsParametersPromise,
              getMetszetEloirasByFeatureIdArrayPromise: _getMetszetEloirasByFeatureIdArrayPromise,
              getMetszetByFeatureIdPromise: _getMetszetByFeatureIdPromise,
              extractEloirasokByKezelesiEgyseg: _extractEloirasokByKezelesiEgysegNew,
              putModifiedEloirasokPromise: _putModifiedEloirasokPromise,
              getModifiedEloirasok: _getModifiedEloirasok
            };
          }];
  }]);